import React from 'react';
import { TablePagination, Paper, Table, TableContainer } from '@mui/material';
import { DatasetTableHead } from './DatasetTableHead';
import { DatasetTableBody } from './DatasetTableBody';
const classes = {
    paper: {
        width: '100%',
        marginBottom: '16px',
    },
    table: {
        minWidth: '750px',
    },
};
export const DatasetTable = ({ data, operation, searchQuery, nodes, }) => {
    const { rows } = data;
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('title');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const dense = true;
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (React.createElement(Paper, { sx: classes.paper },
        React.createElement(TableContainer, null,
            React.createElement(Table, { sx: classes.table, "aria-labelledby": 'tableTitle', "aria-label": 'enhanced table' },
                React.createElement(DatasetTableHead, { order: order, orderBy: orderBy, classes: classes, rows: rows, rowsPerPage: rowsPerPage, page: page, dense: dense, onRequestSort: handleRequestSort, operation: operation, searchQuery: searchQuery }),
                React.createElement(DatasetTableBody, { order: order, orderBy: orderBy, classes: classes, rows: rows, rowsPerPage: rowsPerPage, page: page, dense: dense, operation: operation, searchQuery: searchQuery, nodes: nodes }))),
        React.createElement(TablePagination, { rowsPerPageOptions: [5, 8, 10, 20, 25, 100], component: 'div', count: rows.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })));
};
